
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 4","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"14.021","cy":"2","transform":"rotate(90 14.021 2)","fill":"currentColor","r":"2"}}),_c('circle',{attrs:{"cx":"8.009","cy":"2","transform":"rotate(90 8.01 2)","fill":"currentColor","r":"2"}}),_c('circle',{attrs:{"cx":"1.998","cy":"2","transform":"rotate(90 1.998 2)","fill":"currentColor","r":"2"}})])
          )
        }
      }
    